import { resolveTheme, STATUS_COLORS } from '../../designTokens';

const VARIANT_STYLES = {
  success: { background: STATUS_COLORS.success_bg, color: STATUS_COLORS.success },
  warning: { background: STATUS_COLORS.warning_bg, color: STATUS_COLORS.warning },
  error:   { background: STATUS_COLORS.error_bg,   color: STATUS_COLORS.error   },
  neutral: { background: STATUS_COLORS.neutral_bg, color: STATUS_COLORS.neutral },
};

export default function Badge({ theme, variant = 'neutral', children }) {
  const t = theme || resolveTheme();
  const colors = variant === 'accent'
    ? { background: t.accent_soft_bg, color: t.accent_soft_text }
    : VARIANT_STYLES[variant] || VARIANT_STYLES.neutral;

  return (
    <span style={{
      ...colors,
      borderRadius: '10px',
      padding: '2px 8px',
      fontSize: '0.78em',
      fontWeight: '600',
      letterSpacing: '0.01em',
      display: 'inline-block',
    }}>
      {children}
    </span>
  );
}
